import { courseConstants } from "../_constants";
import { courseService } from "../_services";
import { errorActions } from "./";

const fetchCourses = (page, category, subCategory, level) => (dispatch) => {
  dispatch({ type: courseConstants.FETCH_START });
  return courseService
    .fetchCourses(page, category, subCategory, level)
    .then((data) => {
      dispatch({
        type: courseConstants.SET_COURSES,
        payload: {
          isFetching: false,
          currentPage: Number(data?.current_page),
          totalPage: data?.total_page,
          courses: data?.data,
          total: data?.total,
        },
      });
    })
    .catch((error) => {
      dispatch({ type: courseConstants.FETCH_END });
    });
};
const fetchFilteredCourses =
  (page, category, subCategory, level, search) => (dispatch) => {
    dispatch({ type: courseConstants.FETCH_START });
    return courseService
      .fetchFilteredCourses(page, category, subCategory, level, search)
      .then((data) => {
        dispatch({
          type: courseConstants.SET_COURSES,
          payload: {
            isFetching: false,
            currentPage: Number(data?.data?.data?.current_page),
            totalPage: data?.data?.data?.total_page,
            courses: data?.data?.data?.courses,
            total: data?.data?.data?.total,
          },
        });
      })
      .catch((error) => {
        dispatch({ type: courseConstants.FETCH_END });
      });
  };

function myCourses(key, page, url = "my-courses") {
  return async (dispatch) => {
    dispatch({ type: courseConstants.FETCH_START });
    courseService.myCourses(key, url, page).then(
      (res) => {
        if (res?.error) {
          dispatch(failure(res.message));
          dispatch(errorActions.setError(res.message));
        } else {
          dispatch(success(key, res));
        }
      },
      (error) => {
        dispatch({ type: courseConstants.FETCH_END });
        dispatch(failure(error.message));
        dispatch(errorActions.setError(error.message));
      }
    );
  };

  function success(key, data) {
    return {
      type: courseConstants.MY_COURSE_LIST,
      payload: {
        isFetching: false,
        currentPage: Number(data?.current_page),
        totalPage: data?.total_page,
        courses: data?.data,
        key: key,
        total: data?.total,
      },
    };
  }

  function failure(error) {
    return { type: courseConstants.MY_COURSE_LIST_FAILURE, error };
  }
}

const handleResetMyCourseList = (key) => (dispatch) => {
  dispatch({
    type: courseConstants.RESET_MY_COURSELIST,
    payload: {
      isFetching: false,
      currentPage: 1,
      totalPage: 10,
      courses: [],
      key: key,
    },
  });
};

const purchasedCourses = (page) => (dispatch) => {
  dispatch({ type: courseConstants.FETCH_START });
  return courseService
    .purchasedCourses(page)
    .then((data) => {
      dispatch({
        type: courseConstants.SET_PURCHASED_COURSES,
        payload: {
          isFetching: false,
          currentPage: Number(data.current_page),
          totalPage: data.total_page,
          courses: data.data,
        },
      });
    })
    .catch((error) => {
      dispatch({ type: courseConstants.FETCH_END });
    });
};

const viewAwardCourse = (page) => (dispatch) => {
  dispatch({ type: courseConstants.FETCH_START });
  return courseService
    .viewAwardCourse(page)
    .then((data) => {
      dispatch({
        type: courseConstants.SET_VIEW_AWARDS,
        payload: {
          isFetching: false,
          currentPage: Number(data.current_page),
          totalPage: data.total_page,
          courses: data.data,
        },
      });
    })
    .catch((error) => {
      dispatch({ type: courseConstants.FETCH_END });
    });
};

const handleResetCourseList = () => (dispatch) => {
  dispatch({
    type: courseConstants.RESET_COURSELIST,
    payload: {
      isFetching: false,
      currentPage: 1,
      totalPage: 10,
      courses: [],
    },
  });
};

const resetPurchasedCourses = () => (dispatch) => {
  dispatch({
    type: courseConstants.SET_RESET_PURCHASED_COURSES,
    payload: {
      isFetching: false,
      currentPage: 0,
      totalPage: null,
      courses: [],
    },
  });
};

export const courseActions = {
  myCourses,
  fetchCourses,
  fetchFilteredCourses,
  purchasedCourses,
  viewAwardCourse,
  handleResetCourseList,
  handleResetMyCourseList,
  resetPurchasedCourses,
};
